import React, {useEffect, useMemo, useState} from 'react';
import CitizenScienceWelcome from './CitizenScienceWelcome';
import CitizenScienceTutorial from './CitizenScienceTutorial';
import {createCitizenScienceTutorialApi} from './citizenScienceTutorialApi';
import {CitizenScienceIntroductionContext} from './citizenScienceIntroductionContext';

export default function CitizenScienceOnboarding({session, children, active = true}) {
  const [stage, setStage] = useState(() => session.tutorialCompleted || session.introductionSkipped ? 'game'
    : session.tutorialStarted || !session.introductionStateKnown ? 'tutorial' : 'welcome');
  const [replay, setReplay] = useState(false);
  const [entered, setEntered] = useState(active);
  useEffect(() => { if (active) setEntered(true); }, [active]);
  const introductionAvailable = active || entered;
  const api = useMemo(() => stage === 'game' || !introductionAvailable ? null : createCitizenScienceTutorialApi(session.uid, {preview: replay}), [session.uid, stage, replay, introductionAvailable]);
  const openIntroduction = () => {if (active) {setReplay(true); setStage('welcome');}};
  // Practice loading can record that the tutorial has started. Only returning
  // players may prepare the actual game before choosing to enter this screen.
  if (stage !== 'game' && !introductionAvailable) return null;
  return <CitizenScienceIntroductionContext.Provider value={openIntroduction}>
    {stage === 'welcome' ? <CitizenScienceWelcome api={api} preview={replay} active={active}
      onTutorial={() => setStage('tutorial')} onStartSpotting={() => setStage('game')} />
      : stage === 'tutorial' ? <CitizenScienceTutorial key={String(replay)} api={api} autoStart active={active}
        onExit={() => setStage('game')}>{children}</CitizenScienceTutorial> : children}
  </CitizenScienceIntroductionContext.Provider>;
}
